module.exports = __webpack_public_path__ + "assets/logo_estimates.e0b1ddd7.svg";